// extracted by mini-css-extract-plugin
export var errorsContainer = "_qt-1";
export var link = "_qt-0";